import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Sidebar, LangButton } from "@/components/Sidebar";
import { useLang } from "@/lib/i18n";
import { PinGate } from "@/components/PinGate";
import TreePage from "@/pages/TreePage";
import CockpitPage from "@/pages/CockpitPage";
import TeamPage from "@/pages/TeamPage";
import CalculatorsPage from "@/pages/CalculatorsPage";
import EventsPage from "@/pages/EventsPage";
import TerritoryPage from "@/pages/TerritoryPage";
import CorpusPage from "@/pages/CorpusPage";
import GapsPage from "@/pages/GapsPage";
import GuidePage from "@/pages/GuidePage";
import WinePage from "@/pages/WinePage";
import InventoryPage from "@/pages/InventoryPage";

function App() {
  const { lang } = useLang();
  return (
    <BrowserRouter>
      <PinGate>
      <div key={lang} className="dark min-h-screen flex">
        <LangButton />
        <Sidebar />
        <main className="flex-1 min-w-0 lg:ml-60 pb-16 lg:pb-0">
          <Routes>
            <Route path="/" element={<TreePage />} />
            <Route path="/cockpit" element={<CockpitPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/calcolatori" element={<CalculatorsPage />} />
            <Route path="/eventi" element={<EventsPage />} />
            <Route path="/territorio" element={<TerritoryPage />} />
            <Route path="/corpus" element={<CorpusPage />} />
            <Route path="/analisi" element={<GapsPage />} />
            <Route path="/guida" element={<GuidePage />} />
            <Route path="/vini" element={<WinePage />} />
            <Route path="/inventario" element={<InventoryPage />} />
            <Route path="/mappa" element={<TreePage view="map" />} />
          </Routes>
        </main>
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
      </PinGate>
    </BrowserRouter>
  );
}

export default App;
